import { z } from 'zod';

export const CuratorEventItemSchema = z.object({
  image: z.string(),
  label: z.string(),
  title: z.string(),
  displayPeriod: z.string(),
  link: z.string(),
  sourceType: z.string(),
  eventType: z.string(),
  remainingDays: z.coerce.number(),
});

export const CuratorEventsServiceResponseSchema = z.object({
  events: z.array(CuratorEventItemSchema),
});

export type CuratorEventItemDTO = z.infer<typeof CuratorEventItemSchema>;
export type CuratorEventsServiceResponse = z.infer<typeof CuratorEventsServiceResponseSchema>;
